import EnquiryQuestions from './EnquiryQuestions.component';

export default EnquiryQuestions;
